// index.less 必须放置在 import 的 第一个
import './index.less';
import React from 'react';
import Root from '@src/components/root';
import RouteEnhance from '@src/components/route/route-enhance';
import routeConfigs from '@src/pages/app-router/route-configs';
import RouteSwitchEnhance from '@src/components/route/route-switch-enhance';
import { HashRouter as Router } from 'react-router-dom';

// import { isMQQ, isWeiXin } from 'detect-mobile-device';
import debounce from 'lodash.debounce';
import delayLoadFont from '@src/pages/app-router/font.js';

// @qqwxShare(getDefaultShareParams())
export default class AppRouter extends React.PureComponent {
  /**
   * 解决移动端 qq浏览器和微信 曲面屏手机 计算font-size有误，导致页面可以滑动
   */
  componentDidMount () {
    // // 禁用双指缩放
    document.documentElement.addEventListener('touchstart', function (event) {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    }, { passive: false });

    // 禁用双指手势
    document.documentElement.addEventListener('gesturestart', function (e) {
      e.preventDefault();
    }, { passive: false });

    // 禁用双击缩放
    let lastTouchEnd = 0;
    document.documentElement.addEventListener('touchend', function (event) {
      const now = (new Date()).getTime();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    }, { passive: false });

    // document.addEventListener('touchmove', function (event) {
    //   if (event.scale !== 1) {
    //     event.preventDefault();
    //   }
    // }, { passive: false });
    setTimeout(() => {
      delayLoadFont();
    }, 5000);

  }

  renderRouteEnhanceElement () {
    return Object.keys(routeConfigs)
      .sort((a, b) => {
        return (routeConfigs[a].order || 0) - (routeConfigs[b].order || 0);
      })
      .map(key => <RouteEnhance key={key} {...routeConfigs[key]} />);
  }

  resetFontSize = debounce(() => {
    // 折叠屏特殊处理：当物理尺寸较大但报告宽度较小时
    if (window.innerWidth / window.innerHeight > 1) {
      if (document.activeElement.tagName.toLowerCase() === 'input') {
        document.documentElement.style.fontSize = `${window.innerWidth / 10}px`;
        return;
      }
      // 宽度大于高度1倍以上
      document.documentElement.style.fontSize = window.innerWidth / 10 / 2 + 'px';
    } else if (window.innerWidth >= 750) {
      // 平板类型 最大值50px
      document.documentElement.style.fontSize = '50px';
    } else {
      // 正常机型
      document.documentElement.style.fontSize = `${window.innerWidth / 10}px`;
    }
  }, 500);

  render () {
    return (
      <Router>
        <Root>
          <RouteSwitchEnhance>{this.renderRouteEnhanceElement()}</RouteSwitchEnhance>
        </Root>
      </Router>
    );
  }
}
